import type { LangfassungsStand } from './types';

/** D25: der Stand der 60-s-Fassung derselben Folge — ohne Emoji, für Screenreader und Tests. */
export function langfassungText(l: LangfassungsStand): string {
  switch (l.state) {
    case 'FREIGEGEBEN':
      return l.anmerkung ? '60 s: freigegeben, mit Anmerkung' : '60 s: freigegeben';
    case 'OFFEN':
      return '60 s: noch nicht freigegeben';
    case 'FEHLT':
      return '60 s: noch nicht im Admin';
    case 'OHNE_CHRISTINE':
      return '60 s: ohne Christine freigegeben';
  }
}
